import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  GET: 'GET_STAT',
  GET_PROJECT_STATS: 'GET_PROJECT_STATS',
  GET_OTTV: 'GET_OTTV_STATS',
  GET_RTTV: 'GET_RTTV_STATS',
  GET_LPD: 'GET_LPD_STATS',
  GET_COP: 'GET_COP_STATS',
  GET_SEER: 'GET_SEER_STATS',
  GET_BOILER: 'GET_BOILER_STATS',
  GET_HOT_WATER_COP: 'GET_HOT_WATER_COP_STATS',
  GET_PVE: 'GET_PVE_STATS',
  GET_HEE: 'GET_HEE_STATS',
  GET_OTHER_RE: 'GET_OTHER_RE_STATS',
  GET_LIGHTING_POWER: 'GET_LIGHTING_POWER_STATS',
  CLEAR_ALL_STATS: 'CLEAR_ALL_STATS',
};

const getErrorMessage = (err) => {
  return (err.response && err.response.data && err.response.data.detail) || err.message;
};

export const getStat = (startDate, endDate) => ({
  type: ACTION.GET,
  payload: RestClient.request({
    method: 'get',
    url: `${Constants.API_PROJECT_INSPECTION}statistic/`,
    params: {
      start_date: startDate,
      end_date: endDate,
    },
  }).catch(err => Promise.reject(err.response.data.detail)),
});

export const getProjectStats = (params = {}) => ({
  type: ACTION.GET_PROJECT_STATS,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STATS,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getOttvStats = (params = {}) => ({
  type: ACTION.GET_OTTV,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_OTTV,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getRttvStats = (params = {}) => ({
  type: ACTION.GET_RTTV,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_RTTV,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getLpdStats = (params = {}) => ({
  type: ACTION.GET_LPD,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_LPD,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getCopStats = (params = {}) => ({
  type: ACTION.GET_COP,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_COP,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getSeerStats = (params = {}) => ({
  type: ACTION.GET_SEER,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_SEER,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getBoilerStats = (params = {}) => ({
  type: ACTION.GET_BOILER,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_BOILER,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getHotWaterCopStats = (params = {}) => ({
  type: ACTION.GET_HOT_WATER_COP,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_HOT_WATER_COP,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getPveStats = (params = {}) => ({
  type: ACTION.GET_PVE,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_PVE,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getHeeStats = (params = {}) => ({
  type: ACTION.GET_HEE,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_HEE,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getOtherReStats = (params = {}) => ({
  type: ACTION.GET_OTHER_RE,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_OTHER_RE,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const getLightingPowerStats = (params = {}) => ({
  type: ACTION.GET_LIGHTING_POWER,
  payload: RestClient.request({
    method: 'get',
    url: Constants.API_PROJECT_STAT_LIGHTING_POWER,
    params,
  }).catch(err => Promise.reject(getErrorMessage(err))),
});

export const clearAllStats = () => ({
  type: ACTION.CLEAR_ALL_STATS,
});



// WEBPACK FOOTER //
// ./src/redux/stat/stat_actions.js